import signedFetch from './util/signedFetch.js';

export default actCodeBatchId =>
  signedFetch(
    'downloadActCodeForBatch',
    `${__API_BASE__}/admin-console/activation-code-batch/${actCodeBatchId}/download`,
    'GET'
  );
